<!-- <div class="card mt-4">
  <h4 class="card-header">You're logged in with Angular 8 & Basic HTTP Authentication!!</h4>
  <div class="card-body">
    <h6>Users from secure api end point</h6>
    <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
    <ul *ngIf="users">
      <li *ngFor="let user of users">{{user.username}} {{user.roleName}}</li>
    </ul>
  </div>
</div> -->
<div class="text-right col-12 " >
  <div class="">
    <button class="btn btn-outline-success text-dark font-weight-bold" (click)="openModal(newManagerModal)">+ User</button>
  </div>
</div>
<div>
  <div class="row mt-4">
    <div class="col-md-12">
      <form [formGroup]="form" onsubmit="return false">
        <div class="row">
          <div class="col-md-3">
            <label for=""><u>Filter by Role</u></label>
            <select formControlName="role" class="form-control" placeholder="Role">
              <option value="" selected>All</option>
              <option *ngFor="let role of roleList | keyvalue" [value]="role.key">{{role.value}}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label for=""><u>Filter by Username</u></label>
            <input type="text" formControlName="username" class="form-control" placeholder="enter username" />
          </div>
          <div class="col-md-3 col-sm-3 d-flex align-items-end">
            <button class="btn btn-primary btn-sm" (click)="search(form.value)">Search</button>
          </div>
          <div class="col-md-3">
            <label for=""><u>Items Per Page</u></label>
            <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
              <option *ngFor="let ipp of pagingList">{{ipp}}</option>
            </select>
          </div>
        </div>
      </form>
    </div>
  </div>

  <table id="managerList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
    <thead>
      <tr>
        <th>No.</th>
        <th>Username</th>
        <th>Role</th>
        <th>Created At</th>
        <th *ngIf="currentUser.roleName == 'ADMIN'">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="loading">
        <td colspan="5">
          <div class="loader">Loading...</div>
        </td>
      </tr>
      <tr *ngIf="emptyResult">
        <td colspan="5">
          <div class="alert alert-warning">Empty Result...</div>
        </td>
      </tr>
      <tr *ngFor="let user of users; index as i;">
        <td>{{i + 1}}</td>
        <td>{{user.username}}</td>
        <td>{{user.roleName}}</td>
        <td>{{user.createdAt | date}}</td>
        <td class="text-left">
          <button type="button" class="btn btn-sm btn-primary mr-2" placement="top" ngbTooltip="View & Edit" (click)="openModal(editManagerModal, user)">
            <i class="fas fa-pen"></i>
          </button>
          <button type="button" class="btn btn-sm btn-warning mr-2" placement="top" ngbTooltip="Reset Password" (click)="openModal(viewResetPassword, user)">
            <i class="fas fa-lock"></i>
          </button>
          <button type="button" class="btn btn-sm btn-danger mr-2" placement="top" ngbTooltip="Delete" (click)="deleteManager(user)">
            <i class="fas fa-trash"></i>
          </button>
          <a *ngIf="user.roleName == 'CLIENT'" class="btn btn-sm btn-success" [routerLink]="['/dashboard/', user.id, 'grant']" placement="top" ngbTooltip="Grant">Grant</a>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="5" *ngIf="!loading && !emptyResult">
          <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
            lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        </td>
      </tr>
    </tfoot>
  </table>
</div>


<ng-template #editManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editManagerLabel">Edit Manager</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="editManagerForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <label for="username" class="col-sm-4 col-form-label">Username</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" formControlName="username" id="edit-username">
        </div>
      </div>
      <div class="form-group row">
        <label for="email" class="col-sm-4 col-form-label">Role</label>
        <div class="col-sm-8">
          <select formControlName="role" class="form-control" placeholder="Role">
            <option *ngFor="let role of roleList | keyvalue" [value]="role.key">{{role.value}}</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Save changes</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #newManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newManagerLabel">New Manager</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="newManagerForm" (ngSubmit)="onNewSubmit()">
      <div class="form-group row">
        <div class="col-12">
          <small><i class="text-danger">* indicates mandatory field</i></small>
        </div>
        <label for="username" class="col-sm-4 col-form-label"><span class="text-danger">* </span>Username</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" formControlName="username" id="new-username">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.username.errors">
              Username cannot be blank.
            </div>
          </div>
        </div>
        <label for="password" class="col-sm-4 col-form-label"><span class="text-danger">* </span>Password</label>
        <div class="col-sm-8">
          <input type="password" class="form-control" formControlName="password" id="new-password">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.password.errors?.required">
              Password cannot be blank.
            </div>
            <div *ngIf="f.password.errors?.minlegth">
              Password characters must not less than 5.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="email" class="col-sm-4 col-form-label"><span class="text-danger">* </span>Role</label>
        <div class="col-sm-8">
          <select formControlName="role" class="form-control" placeholder="Select">
            <option value="">-select role-</option>
            <option *ngFor="let role of roleList | keyvalue" [value]="role.key">{{role.value}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.role.errors">
              Role cannot be blank.
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add User</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #viewResetPassword let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="resetManagerLabel">Reset Password</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex justify-content-start">
      <h5>To reset password, click on the button below.</h5>
    </div>
    <div class="text-center mt-4">
      <button class="btn btn-outline-primary" *ngIf="!processing" (click)="resetPw()">Reset Password</button>
      <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
    </div>
    <div class="password-show mt-4" *ngIf="showPw">
      <dl class="row mb-0">
        <dt class="col-5 text-primary">New Password:</dt>
        <dd class="col-7">{{rsPw}}</dd>
      </dl>
    </div>
  </div>
</ng-template>
